export const LogoHelper: {
  name: 'logo_helper-635477a461b8'
} = {
  name: 'logo_helper-635477a461b8'
}
